export default "__VITE_ASSET__68c68c8e__"